let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("giDR8")).then(() => parcelRequire('kxF7S'));